import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function AboutHero() {
  return <section className="bg-black pt-[180px] pb-[80px] lg:pt-[200px] lg:pb-[120px] relative overflow-hidden" data-id="element-90">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10" data-id="element-91">
        <AnimateOnScroll className="flex flex-col items-center text-center" data-id="element-92">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-6 font-[Poppins,_sans-serif]" data-id="element-93">
            ABOUT US
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[500] font-[Poppins,_sans-serif] leading-none" data-id="element-94">
            <span className="text-[#FF1493]" data-id="element-95">Be</span> CLINICAL
          </h1>

          <h2 className="font-serif italic text-lg sm:text-xl lg:text-2xl text-white/80 leading-relaxed mb-8" data-id="element-96">
            San Ramon & San Francisco Bay Area
          </h2>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-97"></div>
        </AnimateOnScroll>
      </div>
    </section>;
}